module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "text__title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.$slots.default) ? [_c('br'), _c('span', {
    staticClass: "text__value"
  }, [_vm._t("default")], 2), (_vm.info && _vm.infoText.length) ? [_c('br'), _c('span', {
    staticClass: "text__info"
  }, [_vm._v(_vm._s(_vm.infoText))])] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23e3b813","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/data/components/text/Text.vue
// module id = ef65595b60a0a56c3e4e
// module chunks = 9